



























































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import AddEditModal from './components/add-edit-model.vue';
import { SaleStatusMap } from '@/types/package-management/dictionaries';
import Utils from '@root/utils/common';
import OrganizationSearch from '@/components/organization-search/index.vue';

import { packageList, offlinePackage, editInfo, merchantPackageExport } from '@/api/package-management/index';
@Component({
  name: 'PackageConfig',
  components: { ParkingLotSearch, AddEditModal, OrganizationSearch }
})
export default class PackageConfig extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    orgId: '',
    merchantName: '',
    status: '',
    packageName: ''
  };
  // options = Utils.toLabelVal(businessTypeMap)
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  businessType = ''; //商家类型
  // orgdepId = ''
  private tableLoading: boolean = false;
  editModel: boolean = false; //弹出框是否显示
  tableData: any[] = [];
  isEdit: boolean = false;
  addEditModalData: any = null;
  saleStatusList: any[] = Utils.toLabelVal(SaleStatusMap) || [];
  canExport: boolean = true;
  isOrgRoot: boolean = true;
  isDetail: boolean = false;
  updateStatus: string = '01';
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '套餐名称',
        dataIndex: 'packageName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '所属机构（项目）',
        dataIndex: 'orgDepName',
        width: 180
      },
      {
        title: '适用商家',
        dataIndex: 'merchants',
        width: 180,
        scopedSlots: { customRender: 'merchants' }
      },
      {
        title: '优惠类型',
        dataIndex: 'packageType',
        width: 180
      },
      {
        title: '套餐面额',
        dataIndex: 'quota',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '价格（元）',
        dataIndex: 'price',
        width: 180
      },
      {
        title: '优惠价',
        dataIndex: 'discountPrice',
        width: 200
      },
      {
        title: '销售状态',
        dataIndex: 'status',
        width: 140,
        scopedSlots: { customRender: 'status' }
      },

      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 200
      },

      {
        title: '操作人',
        dataIndex: 'createBy',
        width: 200
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 220,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //table初始化
  current = 1;
  pageSize = 10;
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { orgId, ...rest } = this.filterParam;
      const { status, code, msg, data } = await packageList({
        ...rest,
        orgId: this.filterParam.orgId,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear() {
    this.filterParam = {
      orgId: '',
      merchantName: '',
      status: '',
      packageName: ''
    };
    // @ts-ignore
    this.$refs.orgTree.setRootId();
    this.$nextTick(() => {
      this.searchTable();
    });
  }

  showFlag = false;
  isCopy = false;
  //新增 修改
  async editItem(val?: any, flag?: any, copy?: boolean, edit?: boolean) {
    this.isEdit = edit ? true : false;
    this.isDetail = flag ? true : false;
    this.isCopy = copy ? true : false;
    if (val) {
      this.updateStatus = val.updateStatus;
      try {
        const { status, code, msg, data } = await editInfo({ packageId: val.pkPackageId });
        this.addEditModalData = { ...data };
      } catch (error) {
        return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      }
    } else {
      this.updateStatus = '01';
    }
    if (copy) {
      this.updateStatus = '01';
    }
    if (flag) {
      this.updateStatus = '01';
    }
    this.editModel = true;
  }
  //停售
  deleteItem(val: any) {
    let that = this;
    this.$confirm({
      title: '提示',
      content: `确定要停售该套餐吗？`,
      async onOk() {
        try {
          const { status, msg, code, data } = await offlinePackage({
            status: '00',
            packageId: val.pkPackageId
          });
          if (status === '9999') {
            that.$message.success('停售成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg ? msg : '停售失败');
          }
        } catch (e) {
          that.$message.error((e && e.msg) || '停售失败');
        }
      },
      onCancel() {}
    });
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData();
  }
  //默认选中机构根节点
  selectDefaultRoot(val) {
    this.filterParam.orgId = val;
  }
  //导出
  async downLoadPackage() {
    try {
      if (!this.canExport) return;
      this.canExport = false;
      const { orgId, ...rest } = this.filterParam;
      const { status, code, msg, data } = await merchantPackageExport(
        {
          ...rest,
          orgId: this.filterParam.orgId,
          currPage: this.current,
          pageSize: this.pageSize
        },
        '套餐设置'
      );
    } catch (e) {
      this.$message.error((e && e.msg) || '系统错误，请稍后重试');
    } finally {
      this.canExport = true;
    }
  }
  //获取商家名称
  getMerchantName(val) {
    let str = [];
    if (val.length > 0) {
      for (let i = 0; i < val.length; i++) {
        str.push(val[i].merchantName);
      }
    }
    return str.join('/');
  }
  created() {
    this.$nextTick(() => {
      this.fetchTableData();
    });
  }
  activated() {
    this.fetchTableData();
  }
}
